export default __webpack_public_path__ + "static/media/landscape16.2f8a04b9.jpeg";